import arrowWhite from '@/assets/images/arrow-white.svg';
import character1Image from '@/assets/images/home/character1.png';
import character2Image from '@/assets/images/home/character2.png';
import character3Image from '@/assets/images/home/character3.png';
import linkedin from '@/assets/images/home/linkedin.svg';
import mainMobileImage from '@/assets/images/home/main-mobile.svg';
import mainImage from '@/assets/images/home/main.svg';
import logoWhite from '@/assets/images/logo-white.svg';
import logo from '@/assets/images/logo.svg';
import x from '@/assets/images/play/x.svg';
import telegram from '@/assets/images/telegram.svg';
import { isBSCNetwork } from '@/constant';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';

const Home: React.FC = observer(() => {
    const history = useHistory();

    return (
        <div className="bg-home-bg bg-cover bg-repeat min-h-screen max-md:bg-home-bg-mobile">
            <div className="flex h-[77px] items-center justify-between px-[40px] max-md:px-[20px]">
                <img
                    className="h-[36px] w-[160px] cursor-pointer"
                    src={logo}
                    alt="Lazpad logo"
                    onClick={() => {
                        history.push('/');
                    }}
                />
                <button
                    className="h-[36px] rounded-[4px] w-[134px] bg-black text-white text-[14px]"
                    onClick={() =>
                        window.open(
                            isBSCNetwork
                                ? 'https://lazbubu.ai/my'
                                : 'https://lazbubu.lazai.network/my',
                            '_blank',
                        )
                    }
                >
                    Train Lazbubu
                </button>
            </div>
            <div className="flex justify-between px-[68px] gap-[54px] max-md:hidden">
                <div className="w-[200px] shrink-0 -tracking-[2px] mt-[133px]">
                    <div className="text-[30px] font-silkscreen leading-[30px]">
                        Lazbubu is born as a DAT.
                    </div>
                    <div className="text-[20px] font-silkscreen mt-[40px] leading-[20px]">
                        ·Talk it.
                    </div>
                    <div className="text-[20px] font-silkscreen mt-[10px] leading-[20px]">
                        ·Train it.
                    </div>
                    <div className="text-[20px] font-silkscreen mt-[10px] leading-[20px]">
                        ·Adventure with it.
                    </div>
                </div>
                <div>
                    <img
                        className="mt-[88px] mx-auto h-[440px]"
                        src={mainImage}
                        alt="main"
                    />
                    <div className="flex gap-[40px] justify-center mt-[45px]">
                        <div
                            onClick={() =>
                                window.open(
                                    'https://www.t.me/lazbubufrens',
                                    '_blank',
                                )
                            }
                        >
                            <div className="w-[40px] h-[40px] flex items-center justify-center border border-black border-b-[4px] cursor-pointer">
                                <img src={telegram} alt="telegram" />
                            </div>
                            <div className="bg-primary h-[3px]"></div>
                        </div>
                        <div
                            onClick={() =>
                                window.open('https://x.com/lazbubuai', '_blank')
                            }
                        >
                            <div className="w-[40px] h-[40px] flex items-center justify-center border border-black border-b-[4px] cursor-pointer">
                                <img src={x} alt="x" />
                            </div>
                            <div className="bg-primary h-[3px]"></div>
                        </div>
                        <div
                            onClick={() =>
                                window.open(
                                    'https://www.linkedin.com/company/lazbubu',
                                    '_blank',
                                )
                            }
                        >
                            <div className="w-[40px] h-[40px] flex items-center justify-center border border-black border-b-[4px] cursor-pointer">
                                <img src={linkedin} alt="linkedin" />
                            </div>
                            <div className="bg-primary h-[3px]"></div>
                        </div>
                    </div>
                </div>
                <div className="w-[200px] shrink-0 mt-[83px] flex flex-col items-center">
                    <img
                        className="w-full"
                        src={character1Image}
                        alt="character1"
                    />
                    <div className="font-silkscreen text-[20px] mt-[50px] -tracking-[2px] leading-[20px]">
                        The more you interact, the more it evolves.
                    </div>
                    <div className="relative mt-[138px]">
                        <div className="absolute inset-0 bg-black animate-pulse-ring"></div>
                        <button
                            className="relative w-[80px] h-[80px] bg-black flex items-center justify-center animate-pulse-button"
                            onClick={() =>
                                window.open(
                                    isBSCNetwork
                                        ? 'https://lazbubu.ai/my'
                                        : 'https://lazbubu.lazai.network/my',
                                    '_blank',
                                )
                            }
                        >
                            <img src={arrowWhite} alt="arrow" />
                        </button>
                    </div>
                </div>
            </div>
            <div className="flex-col items-center hidden max-md:flex">
                <img
                    className="mt-[53px] h-[240px]"
                    src={mainMobileImage}
                    alt="main"
                />
                <div className="text-[24px] font-silkscreen mt-[20px] text-center leading-[30px]">
                    Lazbubu is born as a DAT.
                </div>
                <div className="font-silkscreen mt-[40px] leading-[16px]">
                    ·Talk it.
                </div>
                <div className="font-silkscreen mt-[10px] leading-[16px]">
                    ·Train it.
                </div>
                <div className="font-silkscreen mt-[10px] leading-[16px]">
                    ·Adventure with it.
                </div>
                <div className="font-silkscreen mt-[20px] leading-[16px] text-center">
                    The more you interact, the more it evolves.
                </div>
                <div className="relative mt-[43px]">
                    <div className="absolute inset-0 bg-black animate-pulse-ring"></div>
                    <button
                        className="relative w-[80px] h-[80px] bg-black flex items-center justify-center animate-pulse-button"
                        onClick={() =>
                            window.open(
                                isBSCNetwork
                                    ? 'https://lazbubu.ai/my'
                                    : 'https://lazbubu.lazai.network/my',
                                '_blank',
                            )
                        }
                    >
                        <img src={arrowWhite} alt="arrow" />
                    </button>
                </div>
                <div className="flex gap-[40px] justify-center mt-[40px]">
                    <div
                        onClick={() =>
                            window.open(
                                'https://www.t.me/lazbubufrens',
                                '_blank',
                            )
                        }
                    >
                        <div className="w-[40px] h-[40px] flex items-center justify-center border border-black border-b-[4px] cursor-pointer">
                            <img src={telegram} alt="telegram" />
                        </div>
                        <div className="bg-primary h-[3px]"></div>
                    </div>
                    <div
                        onClick={() =>
                            window.open('https://x.com/lazbubuai', '_blank')
                        }
                    >
                        <div className="w-[40px] h-[40px] flex items-center justify-center border border-black border-b-[4px] cursor-pointer">
                            <img src={x} alt="x" />
                        </div>
                        <div className="bg-primary h-[3px]"></div>
                    </div>
                    <div
                        onClick={() =>
                            window.open(
                                'https://www.linkedin.com/company/lazbubu',
                                '_blank',
                            )
                        }
                    >
                        <div className="w-[40px] h-[40px] flex items-center justify-center border border-black border-b-[4px] cursor-pointer">
                            <img src={linkedin} alt="linkedin" />
                        </div>
                        <div className="bg-primary h-[3px]"></div>
                    </div>
                </div>
            </div>
            <div className="relative mb-[200px] max-md:mb-0">
                <div className="bg-primary h-[20px] mt-[84px] max-md:mt-[33px]" />
                <div className="bg-black h-[120px] overflow-hidden relative">
                    <div className="flex items-center h-full animate-scroll-left max-md:animate-scroll-left-mobile whitespace-nowrap">
                        {/* First set of logos */}
                        {Array.from({ length: 15 }).map((_, i) => (
                            <img
                                key={`logo-1-${i}`}
                                src={logoWhite}
                                alt="logo"
                                className="h-[40px] w-auto mx-[40px] shrink-0"
                            />
                        ))}
                        {/* Duplicate set for seamless loop */}
                        {Array.from({ length: 15 }).map((_, i) => (
                            <img
                                key={`logo-2-${i}`}
                                src={logoWhite}
                                alt="logo"
                                className="h-[40px] w-auto mx-[40px] shrink-0"
                            />
                        ))}
                    </div>
                </div>
                <img
                    className="absolute -top-[160px] left-[48px] w-[200px] max-md:hidden"
                    src={character2Image}
                    alt="character2"
                />
                <img
                    className="absolute -bottom-[100px] right-[70px] w-[200px] max-md:hidden"
                    src={character3Image}
                    alt="character3"
                />
            </div>
        </div>
    );
});

export default Home;
